module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.styles)
  }, _vm._l((_vm.notices), function(notice) {
    return _c('Notice', {
      key: notice.name,
      attrs: {
        "prefix-cls": _vm.prefixCls,
        "styles": notice.styles,
        "type": notice.type,
        "content": notice.content,
        "duration": notice.duration,
        "render": notice.render,
        "has-title": notice.hasTitle,
        "withIcon": notice.withIcon,
        "closable": notice.closable,
        "name": notice.name,
        "transition-name": notice.transitionName,
        "on-close": notice.onClose
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-e3792e9e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./~/_iview@2.14.3@iview/src/components/base/notification/notification.vue
// module id = 314
// module chunks = 99 101